module.exports = __webpack_public_path__ + "static/media/loading.dc665038.gif";